/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Fjn_Frankfurt12Inputs */

const en__field_enum_fjn_frankfurt12 = /** @type {(inputs: _Field_Enum_Fjn_Frankfurt12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field_enum_fjn_frankfurt12 = /** @type {(inputs: _Field_Enum_Fjn_Frankfurt12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field_Enum_Fjn_Frankfurt12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_fjn_frankfurt12 = /** @type {((inputs?: _Field_Enum_Fjn_Frankfurt12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Fjn_Frankfurt12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_fjn_frankfurt12(inputs)
	return de__field_enum_fjn_frankfurt12(inputs)
});
export { _field_enum_fjn_frankfurt12 as "_field_enum_FJN_FRANKFURT" }